import s from './TextWithImage.module.scss'
import RichTextArea from '../RichTextArea/RichTextArea'

const TextWithImage = ({ title, content, image, id="" }) => {
    return <div className={s.root} id={id}>
        <div className={s.container}>
            <div className={s.text}>
                <h2>{title}</h2>
                <RichTextArea className={s.richtext} textblob={content}/>
            </div>
            <div className={s.image}>
                <img src={image?.url} alt={image?.label || title} />
            </div>
        </div>
    </div>
}

export default TextWithImage